export default {
  data() {
    return {
      heroConfig: this.$t('pages.programs.Hero'),
      cards: this.$t('pages.programs.ListPrograms'),
      socialsConfig: this.$t('components.Socials'),
    }
  },
}
